// Packages
import PropTypes from 'prop-types'

// Components
import ProcedureForm from 'modules/Procedures/components/Form';

// Other
import useApi from 'hooks/useApi';

const ProcedureCreateScreen = ({ onClose, onSubmit, parent, parentId }) => {

    const { post: createItem, errors } = useApi('/procedures',  false)

	const submit = async (values) => {

        if( await createItem({[parent]: parentId, ...values}, 'Procedure created!') ) {
    
            onSubmit();
        }
    }


    return(
        <ProcedureForm 
            errors={errors} 
            onClose={onClose} 
            onSubmit={submit} 
            type='create' 
        />
    )
}

ProcedureCreateScreen.propTypes = {
	onClose: PropTypes.func,
	onSubmit: PropTypes.func,
    parent: PropTypes.string,
    parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

ProcedureCreateScreen.defaultProps = {
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')},
    parent: '',
    parentId: ''
}

export default ProcedureCreateScreen;